/**
 * A loading block, sized by the caller.
 *
 * The grey is `background-tertiary` — the token for a surface nested inside a
 * card — so it is the right grey against whichever background it lands on, in
 * both themes. It used to be a fixed grey with a `dark:` override, which
 * followed the operating system rather than the app's own theme.
 */
const Skeleton = ({ className = "" }) => {
  return <span className={`inline-block animate-pulse bg-background-tertiary rounded-md ${className}`} />;
};

export default Skeleton;
